import Logo from './ext-logo';
import Icon from './ext-icon';
import Table from './ext-table';
import CopyPaste from './ext-copypaste';
import Layout from './ext-layout';
import Snap from './ext-snap';
import PrintGuideLine from './ext-printguideline';
import TextArea from './ext-textarea';
import Ruler from './ext-ruler';
import Background from './ext-background';
import Grid from './ext-grid';
import Popupmenu from './ext-popupmenu';
import Bleed from './ext-bleed';
import headerAndFooter from './ext-header-footer';

const EXTENSION = {
  Background,
  Bleed,
  CopyPaste,
  Grid,
  headerAndFooter,
  Icon,
  Layout,
  Logo,
  Popupmenu,
  PrintGuideLine,
  Ruler,
  Snap,
  Table,
  TextArea
};

export default EXTENSION;
